import config from "@/configs/config";
import { cn } from "@/shared/libs/commonUtils";
import type { ReactNode } from "react";
import Flex from "../Flex";
import * as constants from "./floatingButtonConstants";
import type { Direction, Variant } from "./floatingButtonTypes";
interface FloatingButtonProps {
  direction?: Direction;
  variant?: Variant;
  classNames?: string;
  children: ReactNode;
}
export default function FloatingButton({
  children,
  classNames,
  variant = "default",
  direction = config.dir === "rtl" ? "bottom-right" : "bottom-left"
}: FloatingButtonProps) {
  return <Flex role="alert" justifyContent={"center"} alignItems={"center"} className={cn("inline-flex fixed w-auto h-auto z-10", constants.directions[direction], constants.variant[variant], classNames)} data-sentry-element="Flex" data-sentry-component="FloatingButton" data-sentry-source-file="index.tsx">
      {children}
    </Flex>;
}